<div class="thumbnail__container">
  @if (item.$$dmsStatus === 'convert' || item.$$dmsStatus === 'done' || item.$$dmsStatus === 'fail') {
    <div
      class="thumbnail__container__status-badge"
      [ngClass]="{'error-bg': item.$$dmsStatus === 'fail'}"
    >
      {{ (item.$$dmsStatus === 'convert' || item.$$dmsStatus === 'done' ? 'TRANS__IMAGE_SELECTOR__UPLOAD_DONE' : 'TRANS__IMAGE_SELECTOR__UPLOAD_FAIL') | translate }}

      @if (item.$$dmsStatus === 'convert' || item.$$dmsStatus === 'done') {
        <mat-icon>
          check
        </mat-icon>
      }
      @else {
        <mat-icon>
          error
        </mat-icon>
      }

      <span>
        {{ (item.$$dmsStatus === 'convert' || item.$$dmsStatus === 'done' ? 'TRANS__IMAGE_SELECTOR__UPLOAD_DONE' : 'TRANS__IMAGE_SELECTOR__UPLOAD_FAIL') | translate }}
      </span>
    </div>
  }

  @if (!item.$$dmsStatus || item.$$dmsStatus === 'done') {
    @if (item.$$thumbnailUrl && !imageLoadError()) {
      <img
        [alt]="'TRANS__THUMBNAIL__IMAGE' | translate"
        [class]="imgClass" [src]="item.$$thumbnailUrl"
        (load)="imageLoadError.set(false)"
        (error)="imageLoadError.set(true)"
      >
    } @else if (imageLoadError()) {
      <mat-icon class="thumbnail__container__thumb-error">
        broken_image
      </mat-icon>
    }
  }
  @else if (item.$$dmsStatus === 'init' || item.$$dmsStatus === 'converting' || item.$$dmsStatus === 'convert') {
    <div class="thumbnail__container__uploading-placeholder">
      @if (item.$$dmsStatus === 'convert') {
        <div class="thumbnail__container__uploading-placeholder__spinner-container">
          <span>
            <mat-progress-spinner
              diameter="16"
              color="accent"
              mode="indeterminate"
            ></mat-progress-spinner>
          </span>

          <span>
            {{ 'TRANS__IMAGE_SELECTOR__CONVERTING' | translate }}
          </span>
        </div>
      }

      @if (item.$$dmsStatus === 'init' || item.$$dmsStatus === 'converting') {
        <mat-progress-bar
          color="accent"
          mode="indeterminate"
        ></mat-progress-bar>
      }
    </div>
  }
</div>
